import type { ServiceType } from '@utility/checkout-utils';
import { SERVICE_TYPE } from '@utility/checkout-utils';

export const GLOBAL_API_PAYMENTS_ENDPOINTS = {
  getPaymentDetails: (
    paymentId: string,
    path: ServiceType = SERVICE_TYPE.PIS
  ) => `/${path}/${paymentId}`,
  patchPaymentDetails: (
    paymentId: string,
    path: ServiceType = SERVICE_TYPE.PIS
  ) => `/${path}/${paymentId}`,
  postCancelPayment: (
    paymentId: string,
    path: ServiceType = SERVICE_TYPE.PIS
  ) => `/${path}/${paymentId}/cancel`,
} as const;
